import { PageHeader } from '@repo/ui'
import { createFileRoute } from '@tanstack/react-router'
import { MailIcon } from 'lucide-react'

import { InvitationsList } from '@/features/invitations/invitations-list'

export const Route = createFileRoute('/_app/convites')({
  component: ConvitesPage,
})

function ConvitesPage() {
  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <PageHeader
        icon={MailIcon}
        title="Convites"
        description="Convites para participar de organizações no AgroSDR"
      />

      <div className="flex-1 overflow-y-auto p-6">
        <div className="mx-auto max-w-2xl">
          <InvitationsList />
        </div>
      </div>
    </div>
  )
}
